module.exports = __webpack_public_path__ + "static/media/document.04b60b5c.png";